import { render, staticRenderFns } from "./t_update_time.vue?vue&type=template&id=56a02927&"
import script from "./t_update_time.vue?vue&type=script&lang=js&"
export * from "./t_update_time.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports